import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Btn, l, Icon } from '@manychat/manyui'

import { windowWidth } from 'utils'
import steps from 'apps/templates/constants/TemplateInstallationSteps'
import { TemplateAnalytics } from 'apps/templates/utils/TemplateAnalytics'

import cm from './Footer.module.css'

export default class Footer extends React.Component {
  static propTypes = {
    step: PropTypes.string.isRequired,
    isFetching: PropTypes.bool.isRequired,
  }

  handleClickBack = () => {
    const { step, onChangeStep, templateHash, isSignedIn } = this.props
    if (step === steps.STEP3) {
      TemplateAnalytics.userActions.logFinalizePageBackClicked({ templateHash })
      onChangeStep(steps.STEP2)
    } else {
      isSignedIn
        ? TemplateAnalytics.userActions.logChoosePageBackClicked({ templateHash })
        : TemplateAnalytics.userActions.logSignInPageBackClicked()

      onChangeStep(steps.STEP1)
    }
  }

  handleClickInstall = async () => {
    const { step, onChangeStep, templateHash, isSignedIn } = this.props
    if (step === steps.STEP1) {
      isSignedIn
        ? TemplateAnalytics.userActions.logReviewPageInstallClicked({ templateHash })
        : TemplateAnalytics.userActions.logReviewPageLogOutInstallClicked()
      onChangeStep(steps.STEP2)
    }
    if (step === steps.STEP3) {
      TemplateAnalytics.userActions.logFinalizePageInstallNowClicked({ templateHash })
      return this.props.onInstallTemplate()
    }
  }

  handleSkipSettings = async () => {
    const { onSkipWizard, templateHash, installationId, isConfigurationPage } = this.props
    const sendEvent = isConfigurationPage
      ? TemplateAnalytics.userActions.logConfigurationPageSkipClicked
      : TemplateAnalytics.userActions.logSuccessPageSkipClicked

    sendEvent({ templateHash, childTemplateId: installationId })

    onSkipWizard()
  }

  render() {
    const { step, isFetching } = this.props

    return (
      <div className={cx('p-a', cm.wrapper)}>
        <div className={cm.left}>
          {Boolean(step !== steps.STEP1 && step !== steps.STEP4) && (
            <a className="d-flex align-center text-secondary" onClick={this.handleClickBack}>
              <Icon.ChevronLeft size={24} />{' '}
              <span>
                {windowWidth() > 720 ? l.translate('Back to previous step') : l.translate('Back')}
              </span>
            </a>
          )}
        </div>

        {Boolean(step !== steps.STEP2 && step !== steps.STEP4) && (
          <Btn
            className="p-x-md"
            primary={step === steps.STEP1}
            success={step === steps.STEP3}
            onClick={this.handleClickInstall}
            disabled={isFetching}
            loader={isFetching}
            data-test-id={`template-installation-step-${step}`}
          >
            {step === steps.STEP3 ? l.translate('Install Now') : l.translate('Install')}
          </Btn>
        )}
        {step === steps.STEP4 && (
          <a onClick={this.handleSkipSettings} className="pointer text-secondary">
            {l.translate('Skip Settings')}
          </a>
        )}

        <div className={cm.right} />
      </div>
    )
  }
}
